(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-redemption"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-gift-redemption]');
    if (!root) return;
    const params = new URLSearchParams(location.search);
    const supplied = window.__euphreeGiftDiscounts || params.getAll('discount');
    delete window.__euphreeGiftDiscounts;
    const raw = supplied.length === 1 ? supplied[0] : null;
    const codes = raw ? raw.split(',') : [];
    const validCodes = supplied.length === 1 && codes.length >= 1 && codes.length <= 2 && codes.every(code => /^[A-Za-z0-9_-]{6,64}$/.test(code));
    const message = root.querySelector('[data-gift-message]');
    const button = root.querySelector('[data-gift-continue]');
    const hero = root.querySelector('[data-stem-image]');
    const summaryImage = root.querySelector('[data-summary-stem]');
    let chosen = null;
    if (!validCodes) message.textContent = supplied.length ? 'This gift link is not formatted correctly. Please use your original registration gift link.' : 'This preview needs a personal gift link to continue. You can still review the color options.';
    root.querySelectorAll('input[name="stem-bag-color"]').forEach(input => {
      input.addEventListener('change', () => {
        chosen = input;
        hero.src = input.dataset.image;
        hero.alt = input.dataset.alt;
        summaryImage.src = input.dataset.image;
        summaryImage.alt = input.dataset.alt;
        root.querySelector('[data-selected-label]').textContent = `— ${input.value}`;
        root.querySelector('[data-summary-color]').textContent = `${input.value} Stem Bag`;
        root.querySelector('[data-color-detail]').textContent = input.value === 'Red' ? 'Red has a beige exterior with a red liner.' : `${input.value} stem bag selected.`;
        button.disabled = !validCodes;
        if (validCodes) message.textContent = 'Your color is selected. Your code will be carried to checkout; Shopify will confirm the final total.';
      });
    });
    button.addEventListener('click', () => {
      if (!chosen || !validCodes) return;
      const discount = codes.map(encodeURIComponent).join(',');
      location.assign(`/cart/${chosen.dataset.variant}:1?discount=${discount}`);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["houston-showroom-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      const carousel = root.querySelector('[data-houston-bike-reviews]');
      const mapElement = root.querySelector('[data-houston-review-products]');
      if (!carousel || !mapElement || carousel.dataset.bikeFilterInitialized) return;
      carousel.dataset.bikeFilterInitialized = 'true';
      let products;
      try { products = new Map(JSON.parse(mapElement.textContent).map((product) => [product.handle, product])); }
      catch (error) { return; }
      const scan = () => {
        let changed = false;
        carousel.querySelectorAll('.swiper-slide').forEach((slide) => {
          const link = slide.querySelector('.kl_reviews__carousel__link');
          if (!link) return;
          let handle;
          try { handle = link.dataset.reviewBikeHandle || new URL(link.href, location.origin).pathname.split('/products/')[1]?.replace(/\/$/, ''); }
          catch (error) { return; }
          const product = products.get(handle);
          if (!product) { slide.remove(); changed = true; return; }
          link.dataset.reviewBikeHandle = handle;
          if (link.getAttribute('href') !== product.url) link.setAttribute('href', product.url);
          const review = link.querySelector('.kl_reviews__carousel__review');
          if (!review || review.querySelector('.houston-showroom__review-bike')) return;
          const media = document.createElement('div');
          media.className = 'houston-showroom__review-bike';
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = product.title;
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 720;
            image.height = 480;
            media.append(image);
          }
          const label = document.createElement('span');
          label.textContent = product.title;
          media.append(label);
          review.prepend(media);
          changed = true;
        });
        if (carousel.querySelector('.kl_reviews__carousel__link')) {
          carousel.dataset.bikeReviewsReady = 'true';
        }
        if (changed) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      new MutationObserver(scan).observe(carousel, {childList: true, subtree: true});
      scan();
    };
    document.querySelectorAll('[data-houston-showroom]').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-houston-showroom]').forEach(setup);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
